"use client";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAdminReviewsAsync,
  fetchAdminReviewsAsync,
  selectAdminReviews,
} from "../../AdminReviews/AdminReviewsSlice";
// import { Star, Edit, Trash2 } from "lucide-react";
import {
  Box,
  Button,
  Input,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Flex,
  Spinner,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Card,
  CardHeader,
  CardBody,
  Heading,
} from "@chakra-ui/react";
import { EditIcon, StarIcon } from "@chakra-ui/icons";
import { FaTrash } from "react-icons/fa";

function AdminReviews() {
  const dispatch = useDispatch();
  const reviews = useSelector(selectAdminReviews);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingReview, setDeletingReview] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await dispatch(fetchAdminReviewsAsync());
        setLoading(false);
      } catch (err) {
        setError("Failed to load reviews. Please try again later.");
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const filteredReviews = Array.isArray(reviews)
    ? reviews.filter(
      (review) =>
        (filterStatus === "all" || review.status === filterStatus) &&
        (review.review_title
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
          review.review_description
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()))
    )
    : [];

  const paginatedReviews = filteredReviews?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredReviews?.length / itemsPerPage);

  const handleDelete = async (uuid) => {
    await dispatch(deleteAdminReviewsAsync({ uuid }));
    dispatch(fetchAdminReviewsAsync());
    onClose();
  };

  const openDeleteModal = (review) => {
    setDeletingReview(review);
    onOpen();
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }).map((_, i) => (
      <StarIcon key={i} color={i < rating ? "#FFD700" : "#D1D5DB"} size={16} />
    ));
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (error) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Box color="red.500">{error}</Box>
      </Flex>
    );
  }

  return (
    <div className="h-screen bg-adminbg contentAdmin p-4">


      <div className=" ">

        <div className="w-full my-5 bg-white rounded-xl">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Feedback Management
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Flex gap={4} flexDir={{ base: "column", sm: "row" }}>
                <Input
                  placeholder="Search reviews..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  maxW="sm"
                />
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <option value="all">All Statuses</option>
                  <option value="approved">Approved</option>
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                </Select>
              </Flex>
            </div>
          </div>

          <Box overflowX="auto">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Rating</Th>
                  <Th>Candidate</Th>
                  <Th>Review</Th>
                  <Th>Company</Th>
                  <Th>Status</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedReviews && paginatedReviews.length > 0 ? (
                  paginatedReviews.map((review) => (
                    <Tr key={review.id}>
                      <Td className="flex-nowrap">
                        {renderStars(review.review_rating)}
                      </Td>
                      <Td className="capitalize">{review.candidate?.name}</Td>
                      <Td>
                        <Box fontWeight="semibold">{review.review_title}</Box>
                        {review?.review_reply && (
                          <Box fontSize="sm" color="gray.500">
                            Reply: {review.review_reply}
                          </Box>
                        )}
                        <Box fontSize="sm" color="gray.600" mt={1}>
                          {review.review_description}
                        </Box>
                      </Td>
                      <Td className="">
                        {review.company_profile?.company_name}
                      </Td>

                      <Td>
                        <Badge
                          colorScheme={
                            review.status === "approved"
                              ? "green"
                              : review.status === "pending"
                                ? "yellow"
                                : "red"
                          }
                        >
                          {review.status}
                        </Badge>
                      </Td>
                      <Td>
                        <Flex gap={2}>
                          {/* <Button size="sm" variant="outline" leftIcon={<EditIcon size={16} />}>Edit</Button> */}
                          <Button
                            size="sm"
                            colorScheme="red"
                            leftIcon={<FaTrash size={16} />}
                            onClick={() => openDeleteModal(review)}
                          >
                            Delete
                          </Button>
                        </Flex>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="5" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>

          {totalPages > 1 && (
            <Flex justify="center" mt={4} gap={2}>
              {Array.from({ length: totalPages }).map((_, index) => (
                <Button
                  key={index}
                  variant={currentPage === index + 1 ? "solid" : "outline"}
                  size="sm"
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </Button>
              ))}
            </Flex>
          )}


          <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Confirm Deletion</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                Are you sure you want to delete this review? This action cannot be
                undone.
              </ModalBody>
              <ModalFooter>
                <Button variant="outline" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  colorScheme="red"
                  ml={3}
                  onClick={() => handleDelete(deletingReview.uuid)}
                >
                  Delete
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default AdminReviews;
